<script lang="ts" setup>
import {
  PCard,
  PCardSize,
  PCol,
  PLayout,
  PRow,
  PSpace,
  PSpaceSize,
  PTextDescription,
  usePrevioDS,
} from '@previo/design-system'
import { Color } from '@previo/codebooks'
import { $t } from '@previo/core'
import dayjs from 'dayjs'
import TipBox from '~/layouts/components/TipBox.vue'
import SwitchLocale from '~/layouts/components/SwitchLocale.vue'
import PrevioLogo from '~/components/PrevioLogo.vue'

const ds = usePrevioDS()
</script>

<template>
  <p-layout>
    <p-row class="p-height-100-dvh" :gutter="PSpaceSize.ZERO">
      <p-col
        v-if="ds.screen().isLaptopAndLarge"
        mobile="12"
        laptop="6"
        class="p-flex id-no-auth-news-section-background"
      >
        <p-card :pa-mobile="PCardSize.ZERO" :pa-laptop="PCardSize.XXL" class="p-flex p-full-height">
          <div class="id-no-auth-news-section-tip-box">
            <tip-box />
          </div>
        </p-card>
      </p-col>

      <p-col mobile="12" laptop="6">
        <p-card :pa-mobile="PCardSize.SM" :pa-laptop="PCardSize.XXL" class="p-flex p-full-height">
          <div v-if="ds.screen().isLaptopAndLarge" class="p-flex p-full-width">
            <previo-logo />
            <p-space :mobile="PSpaceSize.GROW" />
            <switch-locale />
          </div>

          <div class="p-full-width p-safe-area-top">
            <p-space :mobile="PSpaceSize.LG" :laptop="PSpaceSize.ZERO" vertical />

            <div v-if="ds.screen().isMobile" class="p-text-center">
              <previo-logo />
            </div>
            <p-space :mobile="PSpaceSize.XXL" vertical />

            <div>
              <router-view />
            </div>
          </div>

          <div class="id-no-auth-section-footer p-text-center p-full-width">
            <template v-if="ds.screen().isMobile">
              <switch-locale />
              <p-space :mobile="PSpaceSize.MD" vertical />
            </template>

            <p-text-description
              :text="
                $t(`© { year } Previo {'|'} www.previo.app`, { year: dayjs().format('YYYY') })
              "
              :color="Color.GREY_500"
            />
          </div>
        </p-card>
      </p-col>
    </p-row>
  </p-layout>
</template>

<style lang="scss" scoped>
.id-no-auth-news-section {
  margin-top: auto;

  &-background {
    background-image: url('~/assets/images/login/background.png');
    background-repeat: no-repeat;
    background-size: cover;
  }

  &-tip-box {
    margin-top: auto;
  }
}

.id-no-auth-section-footer {
  margin-top: auto;
}
</style>
